/**
 * F1 (tier2-approval-requests §5) — одна развилка на все действия Tier 2 над проектом.
 *
 * До пака диалог собирал `approver_user_id` и объект подписи, а затем утверждал, что
 * действие выполнено. На деле подпись никто не проверял, и человек, выбравший
 * согласующего, не знал, что тот об этом не узнает ([SOLUTION §0]).
 *
 * Теперь развилка честная и ровно одна: назван адресат — уходит ЗАЯВКА и объект не
 * меняется; адресат не нужен (Tier 1, сдвиг ниже порога) — действие исполняется сразу.
 * Разводить это по пяти диалогам значило бы получить пять слегка разных ответов на
 * один вопрос.
 */
import { type ApprovalRequestTaskTypeT, createApprovalRequest } from './approval-requests';

export type ProjectActionOutcome<T> =
  /** Tier 1 — исполнено немедленно. */
  | { mode: 'done'; result: T }
  /** Tier 2 — намерение отправлено, объект не тронут. */
  | { mode: 'requested'; requestId: string; addresseeUserId: string | null };

export async function submitProjectAction<T>(args: {
  projectId: string;
  taskType: ApprovalRequestTaskTypeT;
  reason: string;
  /** Адресат заявки. Пусто — согласование не требуется. */
  addresseeUserId?: string | undefined;
  /** Тело действия сверх причины: новые даты у переноса срока. */
  payload?: Record<string, unknown>;
  /** Прямой путь для Tier 1. Зовётся только когда адресата нет. */
  direct: () => Promise<T>;
}): Promise<ProjectActionOutcome<T>> {
  if (!args.addresseeUserId) {
    return { mode: 'done', result: await args.direct() };
  }
  const request = await createApprovalRequest({
    task_type: args.taskType,
    subject_kind: 'project',
    subject_id: args.projectId,
    addressee_user_id: args.addresseeUserId,
    reason: args.reason,
    ...(args.payload ? { payload: args.payload } : {}),
  });
  return {
    mode: 'requested',
    requestId: request.id,
    addresseeUserId: request.addressee_user_id,
  };
}
